// extracted by mini-css-extract-plugin
export default {"app_d":"Approved_app_d__qaSfS","app":"Approved_app__Qwy+h","app_l":"Approved_app_l__igHTX"};